"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useRouter } from "next/navigation";
import WithAuth from "./WithAuth";

const HomePage = () => {
  const router = useRouter();
  const pathname = usePathname();
  const isRootPath = pathname === "/";

  useEffect(() => {
    if (isRootPath) {
      // Redirect to the login page
      // console.log("Redirecting to /dashboard from root path");
      router.push("/dashboard");
    }
  }, [isRootPath]);

  return null;
};

export default WithAuth(null, null, false)(HomePage);
